import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';

import Address from './content/address';

const Footer = inject("stores") (
    observer (
        class Footer extends Component {

            constructor(props) {
                super();
                this.props = props;
                this.storeUi = this.props.stores.storeUi;
            }

            render() {
                return (
                    <div className="container-footer">
                        <div class="container-content">
                            <div class="content-columns">
                                {/* {!this.props.hide_navigation &&
                                    <div class="content-column">
                                        <h2>Brands</h2>
                                        <ul>
                                            {this.storeUi.sub_nav[0].values.map((nav_item) => (
                                                <li><Link to={"/brands/" + nav_item.name}>{nav_item.display_value}</Link></li>
                                            ))}
                                        </ul>
                                        <h2>Bridal</h2>
                                        <ul>
                                            {this.storeUi.sub_nav[1].values.map((nav_item) => (
                                                <li><Link to={"/bridal/" + nav_item.name}>{nav_item.display_value}</Link></li>
                                            ))}
                                        </ul>
                                    </div>
                                } */}

                                {/* {!this.props.hide_navigation &&
                                    <div class="content-column">
                                        <h2>Company</h2>
                                        <ul>
                                            <li>
                                                <Link to="/about">About</Link>
                                            </li>
                                            <li>
                                                <Link to="/contact">Contact</Link>
                                            </li>
                                        </ul>
                                    </div>
                                } */}

                                <div class="content-column">
                                    <h2>Contact</h2>
                                    <Address 
                                        hide_showroom = {this.props.hide_showroom} 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    )
)
        
export default Footer;